import { render } from "./LocationModal.vue?vue&type=template&id=165dad52&scoped=true&lang=html"
import script from "./LocationModal.vue?vue&type=script&lang=js"
export * from "./LocationModal.vue?vue&type=script&lang=js"

import "./LocationModal.vue?vue&type=style&index=0&id=165dad52&scoped=true&lang=scss"

import exportComponent from "/Users/richken/code/StoryPhonesWebsite/node_modules/@vue/cli-service/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-165dad52"]])

export default __exports__